module.exports = __webpack_public_path__ + "files/3c26aebaade5082a5e8c0c6b0aa8a64d.svg";